// Réplica do StatTile original: label MAIÚSCULA 10px ls-1, valor 22 bold,
// hint 12; emphasis usa surface-alt em vez de card.
type Props = {
  label: string;
  value: string;
  hint?: string;
  emphasis?: boolean;
  className?: string;
  /** Seletor estável para testes e2e (Playwright). */
  testId?: string;
};

export function StatTile({
  label,
  value,
  hint,
  emphasis,
  className = "",
  testId,
}: Props) {
  return (
    <div
      className={`flex min-w-0 flex-1 flex-col gap-1.5 rounded-(--radius-app) border border-border p-4 ${
        emphasis ? "bg-surface-alt" : "bg-card"
      } ${className}`}
    >
      <p className="text-[10px] font-medium tracking-[1px] text-muted-foreground">
        {label.toUpperCase()}
      </p>
      <p
        className="truncate text-[22px] leading-tight font-bold"
        data-testid={testId}
      >
        {value}
      </p>
      {hint && (
        <p
          className={`text-xs ${
            emphasis ? "text-surface-alt-foreground/70" : "text-muted-foreground"
          }`}
        >
          {hint}
        </p>
      )}
    </div>
  );
}
